import { handleHarnessThreadComponentClick, handleHarnessThreadComponentInput, handleHarnessThreadComponentSubmit } from "./harness/actions.js";
import { handleLLMThreadComponentClick, handleLLMThreadComponentDragDrop, handleLLMThreadComponentInput, handleLLMThreadComponentSubmit } from "./llm/actions.js";

export function handleThreadComponentInput(state, target) {
  if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement)) {
    return false;
  }
  if (!target.closest("[data-thread-component]")) {
    return false;
  }
  if (target.closest("[data-decision-id]")) {
    return handleHarnessThreadComponentInput(state, target);
  }
  const form = target.closest("form");
  if (!(form instanceof HTMLFormElement)) {
    return false;
  }
  if (form.id === "thread-message-form") {
    if (currentThreadMode(state) === "llm" && handleLLMThreadComponentInput(state, target)) {
      return true;
    }
    if (currentThreadMode(state) === "harness" && handleHarnessThreadComponentInput(state, target)) {
      return true;
    }
    if (target.name === "prompt") {
      state.composerDraft = target.value;
      return true;
    }
    return false;
  }
  return currentThreadMode(state) === "llm"
    ? handleLLMThreadComponentInput(state, target)
    : handleHarnessThreadComponentInput(state, target);
}

export async function handleThreadComponentSubmit(state, form, options = {}) {
  return currentThreadMode(state) === "llm"
    ? handleLLMThreadComponentSubmit(state, form, options)
    : handleHarnessThreadComponentSubmit(state, form, options);
}

export async function handleThreadComponentClick(state, target, options = {}) {
  return currentThreadMode(state) === "llm"
    ? handleLLMThreadComponentClick(state, target, options)
    : handleHarnessThreadComponentClick(state, target, options);
}

export function handleThreadComponentDragDrop(state, event, options = {}) {
  if (currentThreadMode(state) === "llm") {
    return handleLLMThreadComponentDragDrop(state, event, options);
  }
  return false;
}

function currentThreadMode(state) {
  return String(state.thread?.mode || "").trim().toLowerCase() === "llm" ? "llm" : "harness";
}
